import axios from 'axios'
import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import appConfig from '../../../config'
import { LiveSessionType, PresenterType } from '../../../slices/sessionSlice'
import { LiveSessionPg } from '../livesessions/styled'
import OnDemandCard from './OnDemandCard'

const paramsToCategory = {
  keynote: 'Keynote',
  masterclass: 'Masterclass',
  'special-presentation': 'Special Presentation',
  'other-sessions': 'Free For All',
}

const OnDemandSessions = () => {
  const [speakers, setSpeakers] = useState<PresenterType[]>([])
  const { category } = useParams()

  const [isLoading, setIsLoading] = useState(true)
  const [recordings, setRecordings] = useState<LiveSessionType[]>([])

  // useEffect(() => {
  //   const body = document.querySelector('#root')
  //   body?.scrollIntoView()
  // }, [])

  useEffect(() => {
    axios
      .get(`${appConfig.API_URL}/on-demand`)
      .then(({ status, data }) => {
        setRecordings(data.recordings)
      })
      .catch((err) => {
        console.log(err)
        toast('Unable to retrieve on-demand sessions, please try again later.')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  let sessions = recordings || []
  const currentCategory =
    paramsToCategory[category as keyof typeof paramsToCategory]

  if (currentCategory) {
    sessions = recordings.filter(
      (session: LiveSessionType) => session.category === currentCategory
    )
  }

  const displayHeading = () => {
    if (currentCategory === 'Free For All') {
      return <h2 className="heading">Other Sessions</h2>
    } else if (currentCategory) {
      return <h2 className="heading">{currentCategory}</h2>
    } else {
      return <h1 className="heading">All Recorded Sessions</h1>
    }
  }

  return (
    <LiveSessionPg>
      <div className="container">
        {displayHeading()}
        {isLoading ? (
          <div className="session-grid">
            <span className="placeholder placeholder-wave bg-dark"></span>
            <span className="placeholder placeholder-wave bg-dark"></span>
            <span className="placeholder placeholder-wave bg-dark"></span>
            <span className="placeholder placeholder-wave bg-dark"></span>
            <span className="placeholder placeholder-wave bg-dark"></span>
          </div>
        ) : (
          <div className="session-grid">
            {sessions.map((liveSession: LiveSessionType) => (
              <OnDemandCard
                key={liveSession.id}
                liveSession={liveSession}
                setSpeakers={setSpeakers}
              />
            ))}
          </div>
        )}
      </div>

      {speakers?.length > 0 && (
        <Modal
          show={speakers?.length > 0}
          onHide={() => setSpeakers([])}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          id="speakerModal"
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            {speakers.map((speaker) => (
              <div className="row" key={speaker?.name}>
                <div className="col-md-4">
                  <img
                    className="rounded mb-3"
                    src={speaker?.image}
                    alt="speaker"
                    width="100%"
                  />
                </div>
                <div className="col-md-8">
                  <h3 className="speakerName">{speaker?.name}</h3>
                  <div
                    className="designation"
                    dangerouslySetInnerHTML={{
                      __html: speaker?.designationHtml,
                    }}
                  />
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: speaker?.descriptionHtml,
                    }}
                  />
                </div>
              </div>
            ))}
          </Modal.Body>
        </Modal>
      )}
    </LiveSessionPg>
  )
}

export default OnDemandSessions
